// extracted by mini-css-extract-plugin
export default {"loading":"ProgressiveImg_loading__Z-LyK","loaded":"ProgressiveImg_loaded__HhTo-"};